import { render } from "./ExtraMessageInformation.vue?vue&type=template&id=71f4dd56&scoped=true"
import script from "./ExtraMessageInformation.vue?vue&type=script&lang=js"
export * from "./ExtraMessageInformation.vue?vue&type=script&lang=js"

import "./ExtraMessageInformation.vue?vue&type=style&index=0&id=71f4dd56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f4dd56"]])

export default __exports__